import { UIData, useUIStore } from '../../../hooks/stores/uiStore';
import { FloatingPanel } from '../../common/FloatingPanel';
import { AdvancedElementInfoPanel } from './AdvancedElementInfoPanel';
import { AdvancedLauncherStatesPanel } from './AdvancedLauncherStatesPanel';
import { SimulationPanel } from './SimulationPanel';

export const FloatingPanels = () => {
  const [UIData, setUIData] = useUIStore<UIData>();

  return (
    <>
      {UIData.openModalIDs.includes('advancedLauncherStatesPanel') && (
        <FloatingPanel
          label="Advanced Launcher States Panel"
          x={UIData.advancedLauncherStatesPanelPos.x}
          y={UIData.advancedLauncherStatesPanelPos.y}
          onDrag={(x, y) =>
            y > 0 && setUIData({ advancedLauncherStatesPanelPos: { x, y } })
          }
          onClose={() => setUIData({
            openModalIDs: UIData.openModalIDs.filter(id => id !== 'advancedLauncherStatesPanel')
          })}
        >
          <AdvancedLauncherStatesPanel />
        </FloatingPanel>
      )}

      {UIData.openModalIDs.includes('advancedElementInfoPanel') && (
        <FloatingPanel
          label="Advanced Element Info Panel"
          x={UIData.advancedElementInfoPanelPos.x}
          y={UIData.advancedElementInfoPanelPos.y}
          onDrag={(x, y) =>
            y > 0 && setUIData({ advancedElementInfoPanelPos: { x, y } })
          }
          onClose={() => setUIData({
            openModalIDs: UIData.openModalIDs.filter(id => id !== 'advancedElementInfoPanel')
          })}
        >
          <AdvancedElementInfoPanel />
        </FloatingPanel>
      )}

      {UIData.editorMode === 'simulation' && (
        <FloatingPanel
          label="Simulation Panel"
          x={UIData.simulationPanelPos.x}
          y={UIData.simulationPanelPos.y}
          onDrag={(x, y) =>
            y > 0 && setUIData({ simulationPanelPos: { x, y } })
          }
        >
          <SimulationPanel />
        </FloatingPanel>
      )}
    </>
  );
};
